import React from 'react';
import Shared from 'screens/shared';
import { actions } from 'redux/local';
import { MONITORING_ACTION_TYPE, VALIDATION } from 'constant';

export default ({
  isCancel = false,
  onCancel,
  monitoringAction: monitoringActionEdit = {},
}) => {
  const { id = '', properties = {} } = monitoringActionEdit;
  const { typeProperties = {}, ...restProps } = properties;
  const { emailTo = '' } = typeProperties;
  restProps.email = emailTo;

  const monitoringAction = {
    name: '',
    type: MONITORING_ACTION_TYPE.EMAIL,
    email: '',
    ...restProps,
  };

  const fields = [
    {
      name: 'name',
      type: 'text',
      title: 'Name',
    },
    {
      name: 'type',
      type: 'dropdown',
      title: 'Type',
      values: [[MONITORING_ACTION_TYPE.EMAIL, 'Email']],
    },
    {
      name: 'email',
      type: 'text',
      title: 'Email',
    },
  ];

  const validations = [
    {
      name: 'name',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'name',
      type: VALIDATION.STRING,
      min: 3,
    },
    {
      name: 'name',
      type: VALIDATION.STRING,
      max: 63,
    },
    {
      name: 'email',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'email',
      type: VALIDATION.EMAIL,
    },
  ];

  const onSave = ({
    name, type, email,
  }) => {
    if (id) {
      actions.monitoring.action.update({ id, properties: { name, type, typeProperties: { emailTo: email } } });
      onCancel();
    } else {
      actions.monitoring.action.create({ name, type, typeProperties: { emailTo: email } });
    }
  };

  return (
    <>
      <Shared.forms.Form
        fields={fields}
        fieldsValues={monitoringAction}
        onSubmit={onSave}
        isCancel={isCancel}
        onCancel={onCancel}
        validations={validations}
      />
    </>
  );
};
